'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export function useServiceWorkerNavigation() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined' || !navigator.serviceWorker) return;

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'NAVIGATE' && typeof event.data.url === 'string') {
        router.push(event.data.url);
      }
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);
    return () => navigator.serviceWorker.removeEventListener('message', handleMessage);
  }, [router]);
}
